import { useQueryParam } from '../../../utils/hooks/useQueryParam';
import { useShareTokenContext } from '../contexts/ShareTokenContext';

type EntityType = 'artist' | 'track' | 'playlist';

const queryParamForEntityType: Record<EntityType, string> = {
  artist: 'artistId',
  track: 'trackId',
  playlist: 'playlistId',
};

/**
 * Resolves the entity id for a detail page or one of its child components.
 *
 * - When a share-token is present and pins the same entity type, returns the
 *   id encoded in the JWT payload (URL params are ignored).
 * - When a share-token is present but pins a different entity type, returns
 *   `null` so the caller can render an error state.
 * - Otherwise falls back to the URL query param (`artistId`/`trackId`/`playlistId`).
 */
export const useEntityIdParam = (entityType: EntityType): string | null => {
  const { payload, isPublicMode } = useShareTokenContext();
  const queryParamValue = useQueryParam(queryParamForEntityType[entityType], null, '');

  if (isPublicMode) {
    if (payload?.t === entityType) {
      return payload.id;
    }
    return null;
  }

  return queryParamValue === '' ? null : queryParamValue;
};
